import React from 'react';
import FilterRowItem from './FilterRowItem';
import PropTypes from 'prop-types';
import { Button } from 'portal-commons';

export default function FilterRow(props) {
  const { appliedFilterObj, filterObject, dataAttributes } = props;
  return (
    <div className="filter-applied" {...dataAttributes}>
      <ul className="list-unstyled">
        {appliedFilterObj &&
          Object.keys(appliedFilterObj).map((key) => {
            if (filterObject[key].multiValue) {
              return appliedFilterObj[key]
                .split(',')
                .map((valueItem, index) => (
                  <FilterRowItem
                    key={index}
                    filterLabel={filterObject[key].label}
                    filterValue={
                      filterObject[key].options &&
                      filterObject[key].options.length
                        ? filterObject[key].options.find((item) => {
                            return item.value == valueItem;
                          }).label
                        : valueItem
                    }
                    handleRemoveFilterClick={(key) =>
                      props.handleRemoveFilterClick(key, valueItem)
                    }
                    name={key}
                  />
                ));
            } else {
              return (
                <FilterRowItem
                  key={key}
                  filterLabel={filterObject[key].label}
                  filterValue={
                    filterObject[key].options &&
                    filterObject[key].options.length &&
                    filterObject[key].options.find(
                      (item) => item.value === appliedFilterObj[key]
                    )
                      ? filterObject[key].options.find(
                          (item) => item.value === appliedFilterObj[key]
                        ).label
                      : appliedFilterObj[key]
                  }
                  handleRemoveFilterClick={props.handleRemoveFilterClick}
                  name={key}
                />
              );
            }
          })}
      </ul>
      {Object.keys(appliedFilterObj).length && (
        <>
          <Button
            data-testid="filterRowClearAllFilters"
            portal="mno"
            shape="rounded"
            color="tertiary"
            variant="outline"
            onClick={() => {
              props.handleClearFilter();
            }}
            className="btn-s align-right"
          >
            Clear all filters
          </Button>
        </>
      )}
    </div>
  );
}
FilterRow.propTypes = {
  appliedFilterObj: PropTypes.object.isRequired,
  filterObject: PropTypes.object.isRequired,
};
